export default __webpack_public_path__ + "static/media/imgZavvie.3fc1e041.webp";